import styled from 'styled-components';

export const ChartWrapperS = styled.div`
  //padding: 20px;
  max-height: 500px;
  overflow: auto;
`;
